import type { Moment } from "moment";

/**
 * This function is used to calculate the tour wave cutoff time.
 */
export function calculateTourWaveCutoffTime(
	tourWaveStartTime: Moment,
	cutoffOffset: number,
): Moment {
	const start = tourWaveStartTime.clone();
	let offset = cutoffOffset;

	if (offset % 1 !== 0) {
		start.subtract(0.5, "hours");
		offset = Math.floor(offset);
	}

	while (offset > 0) {
		start.subtract(1, "hour");
		offset--;
		while (start.isWeekend()) {
			start.subtract(1, "day");
		}
	}

	return start;
}
